// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Game Component CSS Module
 * Optimized for high-performance rendering with many game cards
 */
.SWrXvOeZtKiUY9SlGEI4 {
  position: relative;
  border-radius: var(--border-radius-for-game-cards, 5px);
  cursor: pointer;
  aspect-ratio: var(--game-card-aspect-ratio);
  /* Vertical aspect ratio */
  /* No forwards fill: a held fill keeps a compositor layer per card after the fade.
     isolation keeps the stacking context the fill used to create (TOP number z-index -2). */
  animation: hUZYmnaeybzIhvAD2rK_ 0.4s ease-out backwards;
  isolation: isolate;
  flex: 0 0 auto;
  container-type: inline-size;
  /* Mobile-first responsive sizing - matches theme.layout.gameCard */
  width: 100%;
  max-width: 132px;
  height: auto;
  flex-shrink: 0;
  /* Touch optimizations */
  -webkit-tap-highlight-color: transparent;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
}
.SWrXvOeZtKiUY9SlGEI4[data-view='single'] {
  width: 100%;
  max-width: 100%;
  height: 100%;
  max-height: 100%;
}
/* Grid span classes */
.SWrXvOeZtKiUY9SlGEI4[data-cols="1"] {
  grid-column-start: span 1;
}
.SWrXvOeZtKiUY9SlGEI4[data-cols="2"] {
  grid-column-start: span 2;
}
.SWrXvOeZtKiUY9SlGEI4[data-rows="1"] {
  grid-row-start: span 1;
}
.SWrXvOeZtKiUY9SlGEI4[data-rows="2"] {
  grid-row-start: span 2;
}
/* Horizontal game variant */
/* fallow-ignore-next-line unused-export */
.SWrXvOeZtKiUY9SlGEI4.sF7diwF0Rp9kxiM7_Uvg {
  aspect-ratio: 1 / 0.42;
}
/*.gameCard>picture>img {*/
/*  border-radius: var(--border-radius-for-game-cards, 5px);*/
/*  width: 100%;*/
/*  height: 100%;*/
/*  pointer-events: none;*/
/*  vertical-align: middle;*/
/*  object-fit: cover;*/
/*  !* animation: fadeIn 0.3s ease-in-out; *!*/
/*}*/
.xxL3hJGy7llV76Q1Duk8 {
  position: absolute;
  top: 0;
  left: 0;
  width: var(--badge-plate-width, 40%);
  height: auto;
  min-height: 1px;
  /*prevents image not being displayed on some devices*/
  border-radius: var(--border-radius-for-game-cards, 5px) 0 0 0;
  pointer-events: none;
}
/* Remove animation from jackpot badge images */
/* .gameCard .badge,
.gameCard .badge_plate {
  animation: none !important;
} */
@keyframes hUZYmnaeybzIhvAD2rK_ {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
/* fallow-ignore-next-line unused-export */
.SWrXvOeZtKiUY9SlGEI4 .current_players_icon {
  border-radius: 0;
  object-fit: contain;
}
@media (min-width: 1025px) {
  .SWrXvOeZtKiUY9SlGEI4 .current_players_icon {
    width: 13px;
    height: 17px;
  }
}
/* Responsive card sizes */
@media (max-width: 500px) and (min-width: 375px) {
  .SWrXvOeZtKiUY9SlGEI4[data-view='multi'] {
    max-width: 34.2vw;
  }
}
@media (min-width: 501px) {
  .SWrXvOeZtKiUY9SlGEI4[data-view='multi'] {
    max-width: 164px;
  }
}
@media (min-width: 768px) {
  .SWrXvOeZtKiUY9SlGEI4[data-view='multi'] {
    max-width: 164px;
  }
}
@media (min-width: 1026px) {
  .SWrXvOeZtKiUY9SlGEI4[data-view='multi'] {
    max-width: 246px;
  }
}
/* Touch feedback on mobile */
@media (hover: none) and (pointer: coarse) {
  .SWrXvOeZtKiUY9SlGEI4:active {
    transform: scale(0.98);
    transition: transform 0.1s ease;
  }
}
/* Hover effects only on devices with a mouse/trackpad - completely disabled for all touch devices */
@media (hover: hover) and (pointer: fine) {
  .SWrXvOeZtKiUY9SlGEI4:hover .iqhQ4IVne6kk2sNJtguP {
    visibility: hidden;
  }
  .SWrXvOeZtKiUY9SlGEI4:hover .h2jIUYo7D5eIR4uAlSZQ {
    display: flex;
  }
  .SWrXvOeZtKiUY9SlGEI4:hover::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.75);
    border-radius: var(--border-radius-for-game-cards, 5px);
    z-index: 1;
    pointer-events: none;
  }
}
/* Ensure hover effects are completely disabled on touch devices regardless of screen size */
@media (hover: none) and (pointer: coarse) {
  .SWrXvOeZtKiUY9SlGEI4:hover .iqhQ4IVne6kk2sNJtguP {
    visibility: visible !important;
  }
  .SWrXvOeZtKiUY9SlGEI4:hover .h2jIUYo7D5eIR4uAlSZQ {
    display: none !important;
  }
  .SWrXvOeZtKiUY9SlGEI4:hover::before {
    display: none !important;
  }
}
.iqhQ4IVne6kk2sNJtguP {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  pointer-events: none;
}
.zyyCgEClZbpZLenFJvhz {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 20px;
  /* default for single view */
  width: 100%;
  height: 18px;
  font-family: var(--font-family-numeric, 'San Francisco Bold');
  font-weight: 700;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  pointer-events: none;
  text-align: start;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #fff;
  padding: 2px 4px;
  background: linear-gradient(180deg, #00000000 0%, #00000080 100%);
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.zyyCgEClZbpZLenFJvhz::-webkit-scrollbar {
  display: none;
}
.zyyCgEClZbpZLenFJvhz.W3RgBWG8kPvt7kD8qx_A {
  bottom: var(--jp-bottom-band-height, 32px);
}
@media (min-height: 500px) {
  [data-view='single'][data-section='pickRandom'] .zyyCgEClZbpZLenFJvhz.W3RgBWG8kPvt7kD8qx_A {
    bottom: 34px;
    height: 27px;
    padding: 2px 8px;
  }
}
@media (min-width: 1025px) {
  [data-game-card-size="compact"] .zyyCgEClZbpZLenFJvhz.W3RgBWG8kPvt7kD8qx_A {
    height: 18px;
  }
}
.zyyCgEClZbpZLenFJvhz.bzWG7nK24YaeCjYEMAv9 {
  bottom: 0;
  border-radius: 0 0 var(--border-radius-for-game-cards, 5px) var(--border-radius-for-game-cards, 5px);
}
/* Responsive breakpoints - matches theme.layout.gameCard */
@media (max-width: 1024px) {
  .zyyCgEClZbpZLenFJvhz.W3RgBWG8kPvt7kD8qx_A[data-view='multi'] {
    bottom: 24px;
  }
}
@media (min-width: 320px) {
  .zyyCgEClZbpZLenFJvhz.W3RgBWG8kPvt7kD8qx_A[data-view='single'] {
    bottom: 20px;
  }
}
@media (min-width: 430px) {
  .zyyCgEClZbpZLenFJvhz[data-view='multi'] {
    font-size: 12px;
    padding: 2px 6px;
  }
  .zyyCgEClZbpZLenFJvhz.W3RgBWG8kPvt7kD8qx_A[data-view='single'] {
    bottom: 24px;
  }
}
@media (orientation: landscape) and (max-height: 430px) {
  .zyyCgEClZbpZLenFJvhz[data-view='multi'] {
    height: 18px;
  }
}
@media (min-width: 1026px) {
  .zyyCgEClZbpZLenFJvhz[data-view='multi'] {
    font-size: 13px;
    padding: 4px 10px;
    height: 26px;
  }
  .zyyCgEClZbpZLenFJvhz[data-view='single'] {
    height: 42px;
  }
}
/* Smaller font for search cards when card is narrow */
@container (max-width: 120px) {
  .zyyCgEClZbpZLenFJvhz[data-section='search'] {
    --game-info-bar-font-size: 11px;
  }
  .zyyCgEClZbpZLenFJvhz[data-section='search'] .current_players_icon {
    height: 9px;
    width: 7px;
  }
}
/* Disable transitions during rapid switching */
/* fallow-ignore-next-line unused-export */
.sKMsFHvUc_lSFCgVUOuW .SWrXvOeZtKiUY9SlGEI4,
.sKMsFHvUc_lSFCgVUOuW .SWrXvOeZtKiUY9SlGEI4 * {
  transition: none;
}
/* Play button - hidden by default, shown on hover */
.h2jIUYo7D5eIR4uAlSZQ {
  display: none;
}
/* PrizePop icon - positioned above tournament cup */
/* fallow-ignore-next-line unused-export */
.C56fT5PbkhCH9ZjEo4ZA {
  position: absolute;
  width: 20%;
  top: 15%;
  left: 2%;
  cursor: default;
  z-index: 5;
  object-fit: contain;
}
`, "",{"version":3,"sources":["webpack://./src/features/games/components/GameCard/Game.module.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;EACE,kBAAkB;EAClB,uDAAuD;EACvD,eAAe;EACf,2CAA2C;EAC3C,0BAA0B;EAC1B;4FAC0F;EAC1F,uDAAyC;EACzC,kBAAkB;EAClB,cAAc;EACd,2BAA2B;EAC3B,mEAAmE;EACnE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,wBAAwB;EACxB,wCAAwC;EACxC,2BAA2B;EAC3B,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;AACA,sBAAsB;AACtB;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA,4BAA4B;AAC5B,0CAA0C;AAC1C;EACE,sBAAsB;AACxB;AACA,0BAA0B;AAC1B,6DAA6D;AAC7D,iBAAiB;AACjB,kBAAkB;AAClB,0BAA0B;AAC1B,4BAA4B;AAC5B,uBAAuB;AACvB,8CAA8C;AAC9C,IAAI;AACJ;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,oCAAoC;EACpC,YAAY;EACZ,eAAe;EACf,qDAAqD;EACrD,6DAA6D;EAC7D,oBAAoB;AACtB;AACA,+CAA+C;AAC/C;;;GAGG;AACH;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;AACA,0CAA0C;AAC1C;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE;IACE,WAAW;IACX,YAAY;EACd;AACF;AACA,0BAA0B;AAC1B;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA,6BAA6B;AAC7B;EACE;IACE,sBAAsB;IACtB,+BAA+B;EACjC;AACF;AACA,oGAAoG;AACpG;EACE;IACE,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,+BAA+B;IAC/B,uDAAuD;IACvD,UAAU;IACV,oBAAoB;EACtB;AACF;AACA,4FAA4F;AAC5F;EACE;IACE,8BAA8B;EAChC;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;AACF;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,4BAA4B;EAC5B,WAAW;EACX,YAAY;EACZ,6DAA6D;EAC7D,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,iEAAiE;EACjE,qBAAqB;EACrB,wBAAwB;AAC1B;AACA;EACE,aAAa;AACf;AACA;EACE,0CAA0C;AAC5C;AACA;EACE;IACE,YAAY;IACZ,YAAY;IACZ,gBAAgB;EAClB;AACF;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE,SAAS;EACT,oGAAoG;AACtG;AACA,2DAA2D;AAC3D;EACE;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,eAAe;IACf,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,YAAY;EACd;AACF;AACA,sDAAsD;AACtD;EACE;IACE,+BAA+B;EACjC;EACA;IACE,WAAW;IACX,UAAU;EACZ;AACF;AACA,+CAA+C;AAC/C,0CAA0C;AAC1C;;EAEE,gBAAgB;AAClB;AACA,oDAAoD;AACpD;EACE,aAAa;AACf;AACA,oDAAoD;AACpD,0CAA0C;AAC1C;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,QAAQ;EACR,eAAe;EACf,UAAU;EACV,mBAAmB;AACrB","sourcesContent":["/**\n * Game Component CSS Module\n * Optimized for high-performance rendering with many game cards\n */\n.gameCard {\n  position: relative;\n  border-radius: var(--border-radius-for-game-cards, 5px);\n  cursor: pointer;\n  aspect-ratio: var(--game-card-aspect-ratio);\n  /* Vertical aspect ratio */\n  /* No forwards fill: a held fill keeps a compositor layer per card after the fade.\n     isolation keeps the stacking context the fill used to create (TOP number z-index -2). */\n  animation: fadeIn 0.4s ease-out backwards;\n  isolation: isolate;\n  flex: 0 0 auto;\n  container-type: inline-size;\n  /* Mobile-first responsive sizing - matches theme.layout.gameCard */\n  width: 100%;\n  max-width: 132px;\n  height: auto;\n  flex-shrink: 0;\n  /* Touch optimizations */\n  -webkit-tap-highlight-color: transparent;\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  user-select: none;\n}\n.gameCard[data-view='single'] {\n  width: 100%;\n  max-width: 100%;\n  height: 100%;\n  max-height: 100%;\n}\n/* Grid span classes */\n.gameCard[data-cols=\"1\"] {\n  grid-column-start: span 1;\n}\n.gameCard[data-cols=\"2\"] {\n  grid-column-start: span 2;\n}\n.gameCard[data-rows=\"1\"] {\n  grid-row-start: span 1;\n}\n.gameCard[data-rows=\"2\"] {\n  grid-row-start: span 2;\n}\n/* Horizontal game variant */\n/* fallow-ignore-next-line unused-export */\n.gameCard.horizontal {\n  aspect-ratio: 1 / 0.42;\n}\n/*.gameCard>picture>img {*/\n/*  border-radius: var(--border-radius-for-game-cards, 5px);*/\n/*  width: 100%;*/\n/*  height: 100%;*/\n/*  pointer-events: none;*/\n/*  vertical-align: middle;*/\n/*  object-fit: cover;*/\n/*  !* animation: fadeIn 0.3s ease-in-out; *!*/\n/*}*/\n.badgePlate {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: var(--badge-plate-width, 40%);\n  height: auto;\n  min-height: 1px;\n  /*prevents image not being displayed on some devices*/\n  border-radius: var(--border-radius-for-game-cards, 5px) 0 0 0;\n  pointer-events: none;\n}\n/* Remove animation from jackpot badge images */\n/* .gameCard .badge,\n.gameCard .badge_plate {\n  animation: none !important;\n} */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n/* fallow-ignore-next-line unused-export */\n.gameCard :global(.current_players_icon) {\n  border-radius: 0;\n  object-fit: contain;\n}\n@media (min-width: 1025px) {\n  .gameCard :global(.current_players_icon) {\n    width: 13px;\n    height: 17px;\n  }\n}\n/* Responsive card sizes */\n@media (max-width: 500px) and (min-width: 375px) {\n  .gameCard[data-view='multi'] {\n    max-width: 34.2vw;\n  }\n}\n@media (min-width: 501px) {\n  .gameCard[data-view='multi'] {\n    max-width: 164px;\n  }\n}\n@media (min-width: 768px) {\n  .gameCard[data-view='multi'] {\n    max-width: 164px;\n  }\n}\n@media (min-width: 1026px) {\n  .gameCard[data-view='multi'] {\n    max-width: 246px;\n  }\n}\n/* Touch feedback on mobile */\n@media (hover: none) and (pointer: coarse) {\n  .gameCard:active {\n    transform: scale(0.98);\n    transition: transform 0.1s ease;\n  }\n}\n/* Hover effects only on devices with a mouse/trackpad - completely disabled for all touch devices */\n@media (hover: hover) and (pointer: fine) {\n  .gameCard:hover .gameBottomContainer {\n    visibility: hidden;\n  }\n  .gameCard:hover .playButton {\n    display: flex;\n  }\n  .gameCard:hover::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.75);\n    border-radius: var(--border-radius-for-game-cards, 5px);\n    z-index: 1;\n    pointer-events: none;\n  }\n}\n/* Ensure hover effects are completely disabled on touch devices regardless of screen size */\n@media (hover: none) and (pointer: coarse) {\n  .gameCard:hover .gameBottomContainer {\n    visibility: visible !important;\n  }\n  .gameCard:hover .playButton {\n    display: none !important;\n  }\n  .gameCard:hover::before {\n    display: none !important;\n  }\n}\n.gameBottomContainer {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  width: 100%;\n  pointer-events: none;\n}\n.gameInfoBar {\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 20px;\n  /* default for single view */\n  width: 100%;\n  height: 18px;\n  font-family: var(--font-family-numeric, 'San Francisco Bold');\n  font-weight: 700;\n  font-size: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  pointer-events: none;\n  text-align: start;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  color: #fff;\n  padding: 2px 4px;\n  background: linear-gradient(180deg, #00000000 0%, #00000080 100%);\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n}\n.gameInfoBar::-webkit-scrollbar {\n  display: none;\n}\n.gameInfoBar.hasJackpot {\n  bottom: var(--jp-bottom-band-height, 32px);\n}\n@media (min-height: 500px) {\n  [data-view='single'][data-section='pickRandom'] .gameInfoBar.hasJackpot {\n    bottom: 34px;\n    height: 27px;\n    padding: 2px 8px;\n  }\n}\n@media (min-width: 1025px) {\n  [data-game-card-size=\"compact\"] .gameInfoBar.hasJackpot {\n    height: 18px;\n  }\n}\n.gameInfoBar.noJackpot {\n  bottom: 0;\n  border-radius: 0 0 var(--border-radius-for-game-cards, 5px) var(--border-radius-for-game-cards, 5px);\n}\n/* Responsive breakpoints - matches theme.layout.gameCard */\n@media (max-width: 1024px) {\n  .gameInfoBar.hasJackpot[data-view='multi'] {\n    bottom: 24px;\n  }\n}\n@media (min-width: 320px) {\n  .gameInfoBar.hasJackpot[data-view='single'] {\n    bottom: 20px;\n  }\n}\n@media (min-width: 430px) {\n  .gameInfoBar[data-view='multi'] {\n    font-size: 12px;\n    padding: 2px 6px;\n  }\n  .gameInfoBar.hasJackpot[data-view='single'] {\n    bottom: 24px;\n  }\n}\n@media (orientation: landscape) and (max-height: 430px) {\n  .gameInfoBar[data-view='multi'] {\n    height: 18px;\n  }\n}\n@media (min-width: 1026px) {\n  .gameInfoBar[data-view='multi'] {\n    font-size: 13px;\n    padding: 4px 10px;\n    height: 26px;\n  }\n  .gameInfoBar[data-view='single'] {\n    height: 42px;\n  }\n}\n/* Smaller font for search cards when card is narrow */\n@container (max-width: 120px) {\n  .gameInfoBar[data-section='search'] {\n    --game-info-bar-font-size: 11px;\n  }\n  .gameInfoBar[data-section='search'] :global(.current_players_icon) {\n    height: 9px;\n    width: 7px;\n  }\n}\n/* Disable transitions during rapid switching */\n/* fallow-ignore-next-line unused-export */\n.fastSwitching .gameCard,\n.fastSwitching .gameCard * {\n  transition: none;\n}\n/* Play button - hidden by default, shown on hover */\n.playButton {\n  display: none;\n}\n/* PrizePop icon - positioned above tournament cup */\n/* fallow-ignore-next-line unused-export */\n.prizePopIcon {\n  position: absolute;\n  width: 20%;\n  top: 15%;\n  left: 2%;\n  cursor: default;\n  z-index: 5;\n  object-fit: contain;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"gameCard": `SWrXvOeZtKiUY9SlGEI4`,
	"fadeIn": `hUZYmnaeybzIhvAD2rK_`,
	"horizontal": `sF7diwF0Rp9kxiM7_Uvg`,
	"badgePlate": `xxL3hJGy7llV76Q1Duk8`,
	"gameBottomContainer": `iqhQ4IVne6kk2sNJtguP`,
	"playButton": `h2jIUYo7D5eIR4uAlSZQ`,
	"gameInfoBar": `zyyCgEClZbpZLenFJvhz`,
	"hasJackpot": `W3RgBWG8kPvt7kD8qx_A`,
	"noJackpot": `bzWG7nK24YaeCjYEMAv9`,
	"fastSwitching": `sKMsFHvUc_lSFCgVUOuW`,
	"prizePopIcon": `C56fT5PbkhCH9ZjEo4ZA`
};
export default ___CSS_LOADER_EXPORT___;
